module.exports = __webpack_public_path__ + "static/media/chromoskyn_6.240aff5d.gif";